/**
 * Używane w rezerwacji grupowej, gdy próbuje się stworzyć rezerwację, a osiągnięto ich limit
 */
export class MaxAmountOfReservationsInGroupException extends Error {
    constructor() {
        super('Maximum amount of reservations in group reached');
        this.name = "MaxAmountOfReservationsReachedException";
    }
}